import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import KeyValueEditor from './KeyValueEditor';
import { v4 as uuidv4 } from 'uuid';
import Button from '../../Button';
import clientUtils from '../../../Utils/clientUtils';

const keyPairInitState = [
  {
    id: uuidv4(),
    keyItem: '',
    valueItem: '',
  },
];

const RequestHeaders = ({handleContextMenu}) => {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const [keyValue, setKeyValue] = useState();
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);
  const [headers, setHeaders] = useState(keyPairInitState);

  const onKeyPairAdd = () => {
    setHeaders((paneValue) => [
      ...paneValue,
      {
        id: uuidv4(),
        keyItem: '',
        valueItem: '',
      },
    ]);
  };

  const onKeyPairRemove = (keyPair) => {
    let newKeyValues = [...headers];
    newKeyValues = newKeyValues.filter((x) => x.id !== keyPair.id);
    setHeaders(newKeyValues);
  };

  const onKeyPairUpdate = (keyPair) => {
    const elementIndex = headers.findIndex((element) => element.id === keyPair.id);
    // console.log({elementIndex, keyPair})
    if (elementIndex > -1) {
      let newKeyValues = [...headers];
      newKeyValues[elementIndex] = {
        ...newKeyValues[elementIndex],
        keyItem: keyPair.keyItem,
        valueItem: keyPair.valueItem,
      };
      const headersDict = getValues('aiEngineConfig.inferenceOptions.headers');
      // console.log('headersDict', headersDict);
      if (keyPair && keyPair.keyItem !== '' && headersDict && headersDict[keyPair.keyItem] !== 'undefined') {
        setValue('aiEngineConfig.inferenceOptions.headers', clientUtils.convertKeyValueToObject(newKeyValues));
      }
      // console.log('clientUtils.convertKeyValueToObject(newKeyValues)', clientUtils.convertKeyValueToObject(newKeyValues))
      // //
      setHeaders(newKeyValues);
    }
  
  };

  useEffect(() => {
    const newHeaders = getValues('aiEngineConfig.inferenceOptions.headers');
    // console.log('newHeaders', newHeaders)
    let list = [];
    for (let header in newHeaders) {
      const newHeader = {
        id: uuidv4(),
        keyItem: header,
        valueItem: newHeaders[header],
      };
      list.push(newHeader);
    }
    // console.log('list', list);
    setHeaders(list);
  }, []);

  useEffect(() => {

  }, [headers])

  const renderedList = headers.map((keyPair) => {
    // console.log('keyPair', keyPair);
    return (
      <KeyValueEditor
        key={keyPair.id}
        keyPair={keyPair}
        setKeyPair={(keyPairValue) => onKeyPairUpdate(keyPairValue)}
        onKeyPairRemove={() => onKeyPairRemove(keyPair)}
        handleContextMenu={(e) => handleContextMenu(e, {input:'headers', fieldName:keyPair.keyItem})}
      />
    );
  });

  return (
    <>
      {renderedList}
      <Button variant="contained" size="small" onClick={() => onKeyPairAdd()}>
        Add
      </Button>
    </>
  );
};

export default RequestHeaders;
